import React, { useState, createContext, useContext } from 'react';
interface ClientContextType {
  clientName: string;
  setClientName: (name: string) => void;
  companyName: string;
  setCompanyName: (name: string) => void;
}
const ClientContext = createContext<ClientContextType>({
  clientName: 'Tina Uberoi',
  setClientName: () => {},
  companyName: '',
  setCompanyName: () => {}
});
export function ClientProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [clientName, setClientName] = useState('Tina Uberoi');
  const [companyName, setCompanyName] = useState('');
  return <ClientContext.Provider value={{
    clientName,
    setClientName,
    companyName,
    setCompanyName
  }} data-id="element-71">
      {children}
    </ClientContext.Provider>;
}
export function useClient() {
  return useContext(ClientContext);
}